import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      color: theme.palette.text.primary,
      alignItems: 'flex-start',

      '&$dashed $text': {
        textDecoration: 'underline',
        textDecorationStyle: 'dashed',
        textDecorationColor: '#91B6FF',
        textUnderlineOffset: '3px',
      },
    },
    header: {},
    dashed: {},
    grayIcon: {},

    iconCheck: {
      marginRight: theme.spacing(1),
      fontSize: theme.typography.pxToRem(16),
      color: '#41C493',

      '$grayIcon &': {
        color: '#183771',
      },
    },
    iconCross: {
      marginTop: theme.spacing(0.5),
      marginRight: theme.spacing(1.5),
      fontSize: theme.typography.pxToRem(10),
      color: '#DA5667',

      '$grayIcon &': {
        color: '#183771',
      },
    },
    text: {
      color: 'inherit',
      whiteSpace: 'break-spaces',

      '$header &': {
        fontWeight: theme.typography.fontWeightMedium,
      },
      '& b': {
        fontWeight: theme.typography.fontWeightSemiBold,
      },
    },
  }),
  { name: 'PlanFeature' }
);
